import { RuntimeEnvironment } from './runtime-environment';

export function getRuntimeEnvironment(baseUrl?: string): RuntimeEnvironment {
  const url = baseUrl ?? (typeof window !== 'undefined'
    ? window.location.origin
    : process.env.FRONTEND_BASE_URL ?? ''
  );

  if (!url) {
    return RuntimeEnvironment.LOCAL;
  }

  const { hostname } = new URL(url);

  if (hostname === 'alpha.medprev.online') {
    return RuntimeEnvironment.TEST;
  }

  if (hostname === 'beta.medprev.online') {
    return RuntimeEnvironment.HML;
  }

  if (hostname === 'gama.medprev.online') {
    return RuntimeEnvironment.PRD;
  }

  if (hostname === 'medprev.online') {
    return RuntimeEnvironment.PRD;
  }

  return RuntimeEnvironment.LOCAL;
}
